import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JobsService } from 'src/app/services/jobs.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit {
  jobId: string = '';
  loader: boolean = false;
  jobDetail: any = {};
  resumeFile: File | null = null;
  cvFile: File | null = null;
  allowedTypes: string[] = [
    'application/pdf',
    'application/doc',
    'application/ms-doc',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
  ];
  maxSizeMB = 1;
  showSuccessMsg: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private jobService: JobsService,
    private router:Router ,
    private ns: NotificationService
  ) {}

  /**
   * To initialize data and check permissions
   */
  ngOnInit() {
    // Get jobId from query params
    this.route.queryParams.subscribe(params => {
      this.jobId = params['job_id'] || '';
      if (this.jobId) {
        this.getJobDetail();
      }
    });

    // Restrict success page direct access
    const isSuccessPage = this.router.url.includes('application/success');
    if(isSuccessPage && !this.showSuccessMsg) {
      this.router.navigate(['/']);
    }
  }

  /**
   * To get applied job details
   */
  getJobDetail() {
    this.loader = true;
    this.jobService.getJobById(this.jobId).subscribe({
      next: (res) => {
        this.jobDetail = res.job_data;
        if(this.jobDetail.is_applied) {
          this.router.navigate(['/']);
        }
        this.loader = false;
      },
      error: (err) => {
        this.loader = false;
        this.ns.showNotification('error', err.message);
      }
    });
  }

  /**
   * To hande resume file change
   */
  onResumeFileChange(file: File) {
    if(!this.validateFile(file)) { return false; }
    this.resumeFile = file;
  }

  /**
   * To hande cover file change
   */
  onCvFileChange(file: File) {
    if(!this.validateFile(file)) { return false; }
    this.cvFile = file;
  }

  /**
   * To validate file type and size
   */
  validateFile(file: File) {    
    const maxSizeBytes = this.maxSizeMB * 1024 * 1024;
    if (!this.allowedTypes.includes(file.type)) {
      this.ns.showNotification("error", "Invalid file type. Only PDF, Doc/Docx are allowed.");
      return false;
    }
    if (file.size > maxSizeBytes) {
      this.ns.showNotification("error", `File size should not exceed ${this.maxSizeMB} MB.`);
      return false;
    }
    return true;
  }

  /**
   * To handle form submission
   */
  submitJobApplication() {
    if (!this.resumeFile && !this.cvFile) {
      this.ns.showNotification("error", "Please fill in the mandatory fields. Resume and Cover Letter are required.");
      return;
    }

    else if (!this.resumeFile) {
      this.ns.showNotification("error", "Please upload Resume.");
      return;
    }

    else if (!this.cvFile) {
      this.ns.showNotification("error", "Please upload Cover Letter.");
      return;
    }

    const postData = {
      job_id: this.jobDetail._id,
      resumeFile: this.resumeFile,
      cvFile: this.cvFile
    };

    this.loader = true;
    this.jobService.applyForJob(postData).subscribe({
      next: (res) => {
        this.loader = false;
        this.ns.showNotification("success", res.message);
        this.showSuccessMsg = true;
        this.router.navigate(['/job-portal/application/success'], {queryParams: { job_id: this.jobDetail._id }});
      },
      error: (err) => {
        this.loader = false;
        this.ns.showNotification("error", `Failed to submit the application: `+err.message);
      }
    });
  }
}
